"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Composition = exports.CompositionStatusKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_Composition_Attester_1 = require("./RTTI_Composition_Attester");
var RTTI_Composition_RelatesTo_1 = require("./RTTI_Composition_RelatesTo");
var RTTI_Composition_Event_1 = require("./RTTI_Composition_Event");
var RTTI_Composition_Section_1 = require("./RTTI_Composition_Section");
var CompositionStatusKind;
(function (CompositionStatusKind) {
    CompositionStatusKind["_preliminary"] = "preliminary";
    CompositionStatusKind["_final"] = "final";
    CompositionStatusKind["_amended"] = "amended";
    CompositionStatusKind["_enteredInError"] = "entered-in-error";
})(CompositionStatusKind = exports.CompositionStatusKind || (exports.CompositionStatusKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_Composition = t.recursion('IComposition', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('Composition'),
            type: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            author: t.array(RTTI_Reference_1.RTTI_Reference)
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: RTTI_Identifier_1.RTTI_Identifier,
            status: (0, EnumType_1.createEnumType)(CompositionStatusKind, 'CompositionStatusKind'),
            _status: RTTI_Element_1.RTTI_Element,
            category: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            subject: RTTI_Reference_1.RTTI_Reference,
            encounter: RTTI_Reference_1.RTTI_Reference,
            date: RTTI_dateTime_1.RTTI_dateTime,
            _date: RTTI_Element_1.RTTI_Element,
            title: t.string,
            _title: RTTI_Element_1.RTTI_Element,
            confidentiality: RTTI_code_1.RTTI_code,
            _confidentiality: RTTI_Element_1.RTTI_Element,
            attester: t.array(RTTI_Composition_Attester_1.RTTI_Composition_Attester),
            custodian: RTTI_Reference_1.RTTI_Reference,
            relatesTo: t.array(RTTI_Composition_RelatesTo_1.RTTI_Composition_RelatesTo),
            event: t.array(RTTI_Composition_Event_1.RTTI_Composition_Event),
            section: t.array(RTTI_Composition_Section_1.RTTI_Composition_Section)
        })
    ]);
});
//# sourceMappingURL=RTTI_Composition.js.map